var map = {
	"./aids1.jpg": 4605,
	"./aids2.jpg": 5378,
	"./aids3.jpg": 3439,
	"./aids4.jpg": 8804,
	"./aids5.jpg": 609,
	"./aids6.jpg": 4758,
	"./aids7.jpg": 4867,
	"./cncrtobacco1.jpg": 7881,
	"./cncrtobacco2.jpg": 4798,
	"./cncrtobacco3.jpg": 6283,
	"./cncrtobacco4.jpg": 6280,
	"./covidtime1.jpg": 8214,
	"./covidtime2.jpg": 7825,
	"./covidtime3.jpg": 9780,
	"./covidtime4.jpg": 6159,
	"./drug1.jpeg": 6481,
	"./drug2.jpeg": 8192,
	"./drug3.jpeg": 5239,
	"./notobaccoday1.jpeg": 1291,
	"./notobaccoday2.jpeg": 8062,
	"./notobaccoday3.jpeg": 8821,
	"./notobaccoday4.jpeg": 1008
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8539;